import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {TenantResponse} from '../../../generated-client/generated-api-client';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {
  isFormModifiedDataService,
  SimpleNavigationService
} from "../../../services/data-services/navigation-data-services";

@Component({
  selector: 'app-tenant-form',
  templateUrl: './tenant-form.component.html',
  styleUrls: ['./tenant-form.component.sass'],
})
export class TenantFormComponent {
  @Input() response!: Observable<TenantResponse>;
  @Output() onSubmitCallback: EventEmitter<any> = new EventEmitter();

  tenantForm!: FormGroup;
  isLoading: boolean = true;

  constructor(
    private _errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService,
    private _navigationService: SimpleNavigationService
  ) { }

  ngOnInit(): void {
    this.response?.subscribe(
      next => this.setForm(next),
      error => this._errorProcessorService.processError(error, false, true)
    );

    if (!this.response) {
      this.setForm();
    }
  }

  get id() {
    return this.tenantForm.get('id')!;
  }

  get name() {
    return this.tenantForm.get('name')!;
  }

  get systemId() {
    return this.tenantForm.get('systemId')!;
  }

  get examReportModifiableLater() {
    return this.tenantForm.get('examReportModifiableLater')!;
  }

  onSubmit(): void {
    this.onSubmitCallback.emit([this.tenantForm]);
  }

  onGoBack(path: string){
    this._navigationService.navigateTo(path);
  }

  setForm(response?: TenantResponse): void {
    this.tenantForm = new FormGroup({
      id: new FormControl(response?.id),
      name: new FormControl(response?.name, [Validators.required]),
      systemId: new FormControl(response?.systemId, [
        Validators.required,
        Validators.pattern('^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$'),
      ]),
      examReportModifiableLater: new FormControl(response?.examReportModifiableLater ?? false)
    });
    this._errorProcessorService.formGroup = this.tenantForm;
    this.isLoading = false;
    this.tenantForm.valueChanges.subscribe(() => {
      this._isFormModifiedDataService.isFormModified = true;
    });
  }
}
